import { render, staticRenderFns } from "./gongl.vue?vue&type=template&id=fc25acfe&scoped=true&"
import script from "./gongl.vue?vue&type=script&lang=js&"
export * from "./gongl.vue?vue&type=script&lang=js&"
import style0 from "./gongl.vue?vue&type=style&index=0&id=fc25acfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc25acfe",
  null
  
)

export default component.exports